import { useContext } from 'react'
import ModalSidebarContext from './ModalSidebarContext'

function useModalSidebarToBackdrop() {
  const { setToBackdrop } = useContext(ModalSidebarContext)
  return setToBackdrop ?? (() => {})
}

export default useModalSidebarToBackdrop
